

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.Cv9nzznZ.js","_app/immutable/chunks/disclose-version.Bi-7vFWM.js","_app/immutable/chunks/runtime.BKGIxFgY.js","_app/immutable/chunks/legacy.oiMHjDpG.js","_app/immutable/chunks/render.DOceNgWU.js","_app/immutable/chunks/svelte-head._iSOXuIs.js","_app/immutable/chunks/lifecycle.DzCSOJyU.js","_app/immutable/chunks/entry.m_X2-8qj.js","_app/immutable/chunks/index-client.gWhqflAf.js","_app/immutable/chunks/index.DcUcfCTL.js"];
export const stylesheets = [];
export const fonts = [];
